import type { ComponentPropsWithRef } from "react";

export const DownloadIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg width="22" height="26" viewBox="0 0 22 26" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9997 0.083252C11.6901 0.083252 12.2497 0.642902 12.2497 1.33325V14.9821L16.7824 10.4494C17.2706 9.96118 18.0621 9.96118 18.5502 10.4494C19.0384 10.9375 19.0384 11.729 18.5502 12.2172L11.8835 18.8838C11.6491 19.1182 11.3312 19.2499 10.9997 19.2499C10.6681 19.2499 10.3502 19.1182 10.1158 18.8838L3.44912 12.2172C2.96096 11.729 2.96097 10.9375 3.44912 10.4494C3.93728 9.96118 4.72873 9.96118 5.21691 10.4494L9.74971 14.9822V1.33325C9.74971 0.642902 10.3093 0.083252 10.9997 0.083252Z"
      fill="currentColor"
    />
    <path
      d="M2.91699 20C2.91699 19.3096 2.35734 18.75 1.66699 18.75C0.976632 18.75 0.416992 19.3096 0.416992 20V21.3333C0.416992 23.4964 2.17054 25.25 4.33365 25.25H17.667C19.8301 25.25 21.5837 23.4964 21.5837 21.3333V20C21.5837 19.3096 21.024 18.75 20.3337 18.75C19.6433 18.75 19.0837 19.3096 19.0837 20V21.3333C19.0837 22.1157 18.4494 22.75 17.667 22.75H4.33365C3.55125 22.75 2.91699 22.1157 2.91699 21.3333V20Z"
      fill="currentColor"
    />
  </svg>
);
